// src/components/NavBar.jsx
import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  const navItems = [
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Insights', path: '/insights' },
    { name: 'Media', path: '/media' },
    { name: 'CSR', path: '/csr' },
    { name: 'Career', path: '/careers' },
  ]

  const isActive = (path) => location.pathname === path
  
  // Check if current page needs dark text (light background pages)
  const isDarkTextPage = location.pathname === '/contact'

  return (
    <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
      <div className="w-full px-4 sm:px-6 lg:px-0">
        <div className="font-inter flex justify-between items-center h-20 w-full">

          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center lg:ml-[5%]">
            {isDarkTextPage ? (
              <img
                src="/1_20251023_102853_0000.svg"
                alt="Ofanda Africa logo"
                className="h-48 w-auto object-contain lg:hidden"
              />
            ) : (
              <img
                src="/4_20251023_102853_0003.svg"
                alt="Ofanda Africa logo"
                className="h-48 w-auto object-contain lg:hidden"
              />
            )}

            <img
              src="/9.svg"
              alt="Ofanda Africa logo"
              className="hidden lg:block w-auto object-contain"
              style={{ height: 'clamp(18rem, 18vw, 22rem)', marginTop: 'clamp(1rem, 23vw, 9rem)' }}
            />
          </Link>

          {/* Desktop Navigation - Responsive spacing */}
          <div className="hidden lg:flex items-center justify-center flex-1 px-4" style={{ gap: 'clamp(0.75rem, 3vw, 4rem)' }}>
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`relative font-medium tracking-wide transition-colors duration-300 pb-1 whitespace-nowrap ${
                  isActive(item.path)
                    ? 'text-ofanda-yellow'
                    : isDarkTextPage 
                      ? 'text-gray-900 hover:text-ofanda-yellow'
                      : 'text-white hover:text-ofanda-yellow'
                }`}
                style={{ fontSize: 'clamp(0.875rem, 1.2vw, 1.125rem)' }}
              >
                {item.name}
                {/* Yellow underline for active item */}
                {isActive(item.path) && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-ofanda-yellow"></span>
                )}
              </Link>
            ))}
          </div>

          {/* Contact Button (Desktop) */}
          <div className="hidden lg:flex lg:mr-[5%]">
            <Link
              to="/contact"
              className={`rounded font-semibold tracking-wide transition whitespace-nowrap ${
                isDarkTextPage
                  ? 'bg-gray-900 text-white hover:bg-ofanda-yellow hover:text-gray-900'
                  : 'bg-white text-gray-900 hover:bg-ofanda-yellow hover:text-gray-900'
              }`}
              style={{ 
                padding: 'clamp(0.5rem, 0.8vw, 0.75rem) clamp(1.5rem, 2vw, 2rem)',
                fontSize: 'clamp(0.875rem, 1.2vw, 1.125rem)'
              }}
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`focus:outline-none focus:ring-2 focus:ring-ofanda-yellow ${
                isDarkTextPage ? 'text-gray-900 hover:text-ofanda-yellow' : 'text-white hover:text-ofanda-yellow'
              }`}
            >
              {isMobileMenuOpen ? (
                // X icon when menu is open
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                // Hamburger icon when menu is closed
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg rounded-lg mt-2 py-2">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-2 text-sm font-medium ${
                  isActive(item.path)
                    ? 'text-ofanda-indigo bg-indigo-50'
                    : 'text-gray-700 hover:text-ofanda-indigo hover:bg-ofanda-yellow'
                }`}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Contact CTA for Mobile */}
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block mx-4 my-3 text-center bg-ofanda-yellow text-gray-900 py-2 rounded-full font-semibold"
            >
              Contact Us
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
}

export default NavBar